<ion-app>
	<app-loader style="z-index: 9999"></app-loader>
	<div id="splash-screen">
		<img style="height: 40%; max-width: 50%" src="assets/images/logo.svg" />
	</div>
	<ion-router-outlet></ion-router-outlet>
</ion-app>
